import ReviewsOverviewModal from './ReviewsOverviewModal';

export default ReviewsOverviewModal;
